import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios from "axios";

export const getAdahiSetting = createAsyncThunk(
  "adahi/getAdahiSetting",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}adahi/setting`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
);
